'use client';

import { useEffect, useRef, useState } from 'react';
import { useTranslations } from 'next-intl';
import { css } from '@/styled-system/css';

type Props = {
  count: number | null;
  isSearching: boolean;
  filterInteractionSeq: number;
};

export function SearchResultsStatus({ count, isSearching, filterInteractionSeq }: Props) {
  const t = useTranslations('search');
  const lastFilterInteraction = useRef(filterInteractionSeq);
  const [announcement, setAnnouncement] = useState({ text: '', interactionSeq: filterInteractionSeq });
  const searchingMessage = t('searching');
  const resultMessage = count === null ? '' : t('rentalsFound', { count });
  const filtersAppliedMessage = t('filtersApplied');

  useEffect(() => {
    if (isSearching) {
      setAnnouncement({ text: searchingMessage, interactionSeq: filterInteractionSeq });
      return;
    }
    if (count === null) {
      setAnnouncement({ text: '', interactionSeq: filterInteractionSeq });
      lastFilterInteraction.current = filterInteractionSeq;
      return;
    }
    const filtersChanged = lastFilterInteraction.current !== filterInteractionSeq;
    lastFilterInteraction.current = filterInteractionSeq;
    setAnnouncement({
      text: filtersChanged ? `${filtersAppliedMessage} ${resultMessage}` : resultMessage,
      interactionSeq: filterInteractionSeq,
    });
  }, [count, isSearching, filterInteractionSeq, searchingMessage, resultMessage, filtersAppliedMessage]);

  return (
    <div role="status" aria-live="polite" aria-atomic="true" className={css({ srOnly: true })}>
      {announcement.text && <span key={announcement.interactionSeq}>{announcement.text}</span>}
    </div>
  );
}
